import { useEffect, useState } from "react";
import styles from "../../../ProductsDetails.module.css";
import { useTranslation } from "react-i18next";
import AnimatedDetailsText from "../../../AnimatedDetailsText";
import ModelSlider from "../../../ModelSlider";

function TenFunctionSensor() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  //const [imagesLoaded, setImagesLoaded] = useState({});
  const { i18n } = useTranslation(); // إضافة i18n للحصول على اللغة الحالية

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const handleImageLoad = (index) => {
  //   setImagesLoaded((prevState) => ({
  //     ...prevState,
  //     [index]: true,
  //   }));
  // };
  const { t } = useTranslation();

    // const basePath = `${process.env.PUBLIC_URL}/images/01-tis-bus/sensors-details/10-function-sensor`;
  // const smallScreenPath = `${basePath}/smallScreens`;

  const imageBasePath = isSmallScreen
    ? `${process.env.PUBLIC_URL}/images/01-tis-bus/sensors-details/10-function-sensor/smallScreens`
    : `${process.env.PUBLIC_URL}/images/01-tis-bus/sensors-details/10-function-sensor`

  const modelBasePath = `${process.env.PUBLIC_URL}/images/01-tis-bus/sensors-details/10-function-sensor`

  const videoBasePath = `${process.env.PUBLIC_URL}/images/01-tis-bus/sensors-details/10-function-sensor`; // Assuming video path
  

  // const defaultTextAlign = "center";
  // const isArabic = i18n.language === "ar";

  const mediaData = [
    {
      type: "image",
      src: isSmallScreen ? "01.jpg" : "01.jpg",
      title: t(`sensor10Function.title1`),
      subtitle: t(`sensor10Function.subtitle1`),
      top: isSmallScreen ? "15%" : "25%",
      left: isSmallScreen ? "50%" : "50%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "70%" : "60%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "video",
      src: "02.mp4",
      title: "",
      subtitle: ``,
      top: isSmallScreen ? "83%" : "57%",
      left: isSmallScreen ? "60%" : "27%",
      textAlign: isSmallScreen ? "left" : "left",
      width: isSmallScreen ? "60%" : "26%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "image",
      src: isSmallScreen ? "03.jpg" : "03.jpg",
      title: "",
      subtitle: t(`sensor10Function.subtitle3`),
      top: isSmallScreen ? "26%" : "44%",
      left: isSmallScreen ? "53%" : "25%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "60%" : "26%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#fff" : "#fff",
    },
    {
      type: "video",
      src: "04.mp4",
      title: "",
      subtitle: t(`sensor10Function.subtitle4`),
      top: isSmallScreen ? "38%" : "40%",
      left: isSmallScreen ? "50%" : "50%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "60%" : "26%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#fff" : "#fff",
    },
    {
      type: "image",
      src: isSmallScreen ? "05.jpg" : "05.jpg",
      title: "",
      subtitle: t(`sensor10Function.subtitle5`),
      top: isSmallScreen ? "20%" : "20%",
      left: isSmallScreen ? "50%" : "80%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "80%" : "30%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#fff",
    },
    {
      type: "video",
      src: "06.mp4",
      title: "",
      subtitle: ``,
      top: isSmallScreen ? "15%" : "55%",
      left: isSmallScreen ? "58%" : "18%",
      textAlign: isSmallScreen ? "left" : "left",
      width: isSmallScreen ? "60%" : "26%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "video",
      src: "07.mp4",
      title: "",
      subtitle: isSmallScreen ? t(`sensor10Function.subtitle7Phone`) : t(`sensor10Function.subtitle7`),
      top: isSmallScreen ? "37%" : "40%",
      left: isSmallScreen ? "78%" : "78%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "45%" : "30%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#fff" : "#fff",
    },
    {
      type: "image",
      src: isSmallScreen ? "08.jpg" : "08.jpg",
      title: t(`sensor10Function.title8`),
      subtitle: ``,
      top: isSmallScreen ? "50%" : "50%",
      left: isSmallScreen ? "50%" : "50%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "60%" : "26%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#fff" : "#fff",
    },
    {
      type: "video",
      src: "09.mp4",
      title: ``,
      subtitle: t(`sensor10Function.subtitle9`),
      top: isSmallScreen ? "45%" : "50%",
      left: isSmallScreen ? "25%" : "20%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "50%" : "26%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "image",
      src: isSmallScreen ? "10.jpg" : "10.jpg",
      title: "",
      subtitle: t(`sensor10Function.subtitle10`),
      top: isSmallScreen ? "15%" : "50%",
      left: isSmallScreen ? "50%" : "25%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "60%" : "26%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      
      type: "image",
      src: isSmallScreen ? "11.jpg" : "11.jpg",
      title: "",
      subtitle: t(`sensor10Function.subtitle11`),
      top: isSmallScreen ? "83%" : "70%",
      left: isSmallScreen ? "50%" : "78%",
      textAlign: isSmallScreen
      ? i18n.language === "ar"
        ? "center"
        : "center"
      : i18n.language === "ar"
      ? "right"
      : "left",
      width: isSmallScreen ? "80%" : "26%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#fff" : "#fff",
    },
  ];





  const modelsData = [
    {
      id: 1,
      name: "ES-10F-CM",
      image: `${modelBasePath}/models/01.png`,
    },
  ];
  
  const textDirection = i18n.language === "ar" ? "rtl" : "ltr"; // تعيين اتجاه الكتابة بناءً على اللغة
  return (
    <div className={styles.container} style={{ direction: textDirection }}>
      {mediaData.map((item, index) => (
        <div
          key={index}
          className={styles.imgContainer}
          style={{ position: "relative", width: "100%", display: "block" }}
        >
          {item.type === "image" ? (
            <img
              style={{ width: "100%" }}
              src={`${imageBasePath}/${item.src}`}
              alt=""
            />
          ) : (
            <div className={styles.videoContainer}>
              <video
                className={styles.fullscreenVideo}
                src={`${videoBasePath}/${item.src}`}
                autoPlay
                muted
                loop
                playsInline // مهم لأجهزة iPhone
                disablePictureInPicture // منع خاصية "صورة داخل صورة"
                controls={false} // إخفاء أزرار التحكم
                style={{ display: "block", width: "100%" }}
              />
            </div>
          )}
          <div
            style={{
              position: "absolute",
              top: item.top,
              left: item.left,
              transform: "translate(-50%, -50%)",
              textAlign: item.textAlign,
              width: item.width,
              color: item.color || "#000", // استخدام لون النص المحدد
            }}
          >
            <AnimatedDetailsText
              text={{
                title: item.title,
                subtitle: item.subtitle,
              }}
              textAlign={item.textAlign}
              margin="20px 0"
              padding="10px"
              direction={item.direction}
              zoom={item.zoom}
              fontSize="20px"
              color={item.color} // تمرير اللون إلى `AnimatedDetailsText`
            />
          </div>
          {index === 0 && (
            <div style={{ textAlign: "center" }}>
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  marginTop: "40px",
                }}
              >
                Product Models
              </h1>
              <div>
                <ModelSlider models={modelsData} />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default TenFunctionSensor;

